import { createSelector } from 'reselect';
import { CONVERSATIONS_ADMIN } from 'conversations-internal-schema/constants/Scopes';
import { getScopes } from './getScopes';
export const getIsConversationsAdmin = createSelector(getScopes, scopes => scopes.includes(CONVERSATIONS_ADMIN));